export const pageSize = 10; // pageSize pagination
export const USD = 'USD';
export const registrationUrl = 'https://redirect.eu.com/cecnru/dashboard/copytrading';
export const buttonGroupFlag = 'KIMVIEW';
